import { LoggerProvider, ErrorBoundary } from '@ori/logger';
import { BasketProvider } from '../components';
import { APP_NAME } from '../constants';
import { mainLogger } from '../logger';
import { ApiProvider } from './ApiProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const BasketProviderController = () => /*#__PURE__*/_jsx(LoggerProvider, {
  logger: mainLogger,
  children: /*#__PURE__*/_jsx(ErrorBoundary, {
    areaName: `${APP_NAME}-boundary`,
    children: /*#__PURE__*/_jsx(ApiProvider, {
      children: /*#__PURE__*/_jsx(BasketProvider, {})
    })
  })
});
//# sourceMappingURL=BasketProviderController.js.map